// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"BlockSeo_landingContainer__GpxJl","blockSeo":"BlockSeo_blockSeo__EoPlQ"};